import React from 'react';
import styled from '@emotion/styled';

export const StatusPill = ({ variant = 'waiting', children }) => (
  <Pill $variant={variant}>
    <Dot />
    {children}
  </Pill>
);

export const statusToPill = status => {
  if (!status) return { variant: 'waiting', label: 'Waiting for Data' };

  if (status.inProgress) {
    return { variant: 'inProgress', label: 'In Progress' };
  }

  switch (status.light) {
    case 'red':
      return { variant: 'failed', label: 'Build Failed' };
    case 'yellow':
      return { variant: 'waiting', label: status.text || 'Waiting for Data' };
    case 'green':
    case 'slate':
      return { variant: 'ready', label: 'Ready to be Viewed' };
    default:
      return { variant: 'waiting', label: status.text || 'Waiting for Data' };
  }
};

const PALETTE = {
  ready: { bg: '#D1FAE5', text: '#047857' },
  waiting: { bg: '#FEF9C3', text: '#854D0E' },
  inProgress: { bg: '#DBEAFE', text: '#1D4ED8' },
  failed: { bg: '#FFE4E6', text: '#BE123C' }
};

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  font-family: ${({ theme }) => theme.font.sans};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  background: ${({ $variant }) => PALETTE[$variant].bg};
  color: ${({ $variant }) => PALETTE[$variant].text};
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
`;
